import positionProperties from '../constants/position-properties';

const getRoundedValue = (value) => `${Math.round(value * 1000000) / 1000000}%`;
const setXProperty = (element, value) => {
  element.style.setProperty(positionProperties.X, getRoundedValue(value));
};
const setYProperty = (element, value) =>
  element.style.setProperty(positionProperties.Y, getRoundedValue(value));

const setPositionCustomProperties = (element, { x, y }) => {
  const inlineX = element.style.getPropertyValue(positionProperties.X);
  const inlineY = element.style.getPropertyValue(positionProperties.Y);

  if (x !== undefined && (!inlineX || parseFloat(inlineX) !== x)) {
    setXProperty(element, x);
  }

  if (y !== undefined && (!inlineY || parseFloat(inlineY) !== y)) {
    setYProperty(element, y);
  }
};

export default setPositionCustomProperties;
